module.exports = __webpack_public_path__ + "img/11.1cd154b4.svg";